import * as React from "react";

interface UseHoverFocusReturn {
    showIconButtons: boolean;
    handleMouseEnter: () => void;
    handleMouseLeave: () => void;
    handleFocus: () => void;
    handleBlur: (e: React.FocusEvent<HTMLDivElement>) => void;
}

/**
 * Custom hook to manage hover and focus state for showing/hiding action buttons
 * Handles mouse enter/leave and focus/blur events to control button visibility
 */
export const useHoverFocus = (): UseHoverFocusReturn => {
    const [showIconButtons, setShowIconButtons] = React.useState<boolean>(false);

    const handleMouseEnter = React.useCallback(() => {
        setShowIconButtons(true);
    }, []);

    const handleMouseLeave = React.useCallback(() => {
        setShowIconButtons(false);
    }, []);

    const handleFocus = React.useCallback(() => {
        setShowIconButtons(true);
    }, []);

    const handleBlur = React.useCallback((e: React.FocusEvent<HTMLDivElement>) => {
        // Only hide buttons if focus is leaving the entire container
        if (e.relatedTarget && e.relatedTarget instanceof Node && !e.currentTarget.contains(e.relatedTarget)) {
            setShowIconButtons(false);
        }
    }, []);

    return {
        showIconButtons,
        handleMouseEnter,
        handleMouseLeave,
        handleFocus,
        handleBlur
    };
};
